import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';

import CancelAndRefund from './CancelAndRefund';
import CancelReasonModal from './CancelReason';
import MassCancelAndRefundModal from './MassCancelAndRefund';
import EditLinkModal from './EditLink';
import SetStartCountModal from './SetStartCount';
import SetPartialModal from './SetPartial';
import UpdateRemainsModal from './UpdateRemains';
import SetRemainsModal from './SetRemains';
import OrderDetailsModal from './OrderDetails';
import OrderDetailsSuperAdminModal from './OrderDetailsSuperadmin';
import OrderInfoModal from './OrderInfo';
import UpdateFromProviderModal from './UpdateFromProvider';
import ChangeStatusModal from './ChangeStatus';
import MassChangeStatusModal from './MassChangeStatus';
import MassRequestRefillModal from './MassRequestRefill';
import MassRequestCancelModal from './MassRequestCancel';
import MassUpdateFromProviderModal from './MassUpdateFromProvider';
import ResendModal from './Resend';
import MassResendModal from './MassResend';

import {
  CANCEL_AND_REFUND,
  CANCEL_REASON,
  CHANGE_STATUS,
  EDIT_LINK,
  MASS_CANCEL_AND_REFUND,
  MASS_CHANGE_STATUS,
  MASS_REQUEST_CANCEL,
  MASS_REQUEST_REFILL,
  MASS_RESEND_CONFIRM,
  MASS_UPDATE_FROM_PROVIDER,
  ORDER_DETAILS,
  ORDER_DETAILS_SUPER_ADMIN,
  ORDER_INFO,
  RESEND_ORDER_CONFIRM,
  SET_PARTIAL,
  SET_REMAINS,
  SET_START_COUNT,
  UPDATE_FROM_PROVIDER,
  UPDATE_REMAINS,
} from '../../constants';

const ModalsManager = ({ modal, access, config, values, onHide, onSubmit }) => {
  const modalsComponentsList = [
    {
      modalKey: CANCEL_AND_REFUND,
      Component: CancelAndRefund,
      options: {
        bsSize: 'small',
        className: 'modal-md',
      },
    },
    {
      modalKey: MASS_CANCEL_AND_REFUND,
      Component: MassCancelAndRefundModal,
      options: {
        bsSize: 'small',
        className: 'modal-md',
      },
    },
    {
      modalKey: CANCEL_REASON,
      Component: CancelReasonModal,
      options: {
        bsSize: 'small',
        className: 'modal-md',
      },
    },
    {
      modalKey: EDIT_LINK,
      Component: EditLinkModal,
      options: {
        bsSize: 'small',
        className: 'modal-md',
      },
    },
    {
      modalKey: SET_START_COUNT,
      Component: SetStartCountModal,
      options: {
        bsSize: 'small',
        className: 'modal-md',
      },
    },
    {
      modalKey: SET_PARTIAL,
      Component: SetPartialModal,
      options: {
        bsSize: 'small',
        className: 'modal-md',
      },
    },
    {
      modalKey: UPDATE_REMAINS,
      Component: UpdateRemainsModal,
      options: {
        bsSize: 'small',
        className: 'modal-md',
      },
    },
    {
      modalKey: SET_REMAINS,
      Component: SetRemainsModal,
      options: {
        bsSize: 'small',
        className: 'modal-md',
      },
    },
    {
      modalKey: ORDER_DETAILS,
      Component: OrderDetailsModal,
      options: {},
    },
    {
      modalKey: ORDER_INFO,
      Component: OrderInfoModal,
      options: {},
    },
    {
      modalKey: ORDER_DETAILS_SUPER_ADMIN,
      Component: OrderDetailsSuperAdminModal,
      options: {},
    },
    {
      modalKey: UPDATE_FROM_PROVIDER,
      Component: UpdateFromProviderModal,
      options: {
        bsSize: 'small',
        className: 'modal-confirm__wrapper',
      },
    },
    {
      modalKey: CHANGE_STATUS,
      Component: ChangeStatusModal,
      options: {
        bsSize: 'small',
        className: 'modal-confirm__wrapper',
      },
    },
    {
      modalKey: MASS_CHANGE_STATUS,
      Component: MassChangeStatusModal,
      options: {
        bsSize: 'small',
        className: 'modal-confirm__wrapper',
      },
    },
    {
      modalKey: MASS_REQUEST_REFILL,
      Component: MassRequestRefillModal,
      options: {
        bsSize: 'small',
        className: 'modal-confirm__wrapper',
      },
    },
    {
      modalKey: MASS_REQUEST_CANCEL,
      Component: MassRequestCancelModal,
      options: {
        bsSize: 'small',
        className: 'modal-confirm__wrapper',
      },
    },
    {
      modalKey: MASS_UPDATE_FROM_PROVIDER,
      Component: MassUpdateFromProviderModal,
      options: {
        bsSize: 'small',
        className: 'modal-confirm__wrapper',
      },
    },
    {
      modalKey: RESEND_ORDER_CONFIRM,
      Component: ResendModal,
      options: {
        bsSize: 'small',
        className: 'modal-confirm__wrapper',
      },
    },
    {
      modalKey: MASS_RESEND_CONFIRM,
      Component: MassResendModal,
      options: {
        bsSize: 'small',
        className: 'modal-confirm__wrapper',
      },
    },
  ]
  if (modalsComponentsList.length) {
    return modalsComponentsList.map((item) => {
      const { Component, options } = item;
      const showModal = modal?.openModalKey === item.modalKey;
      return (
        <Modal
          key={`modal-${item.modalKey}`}
          show={showModal}
          backdrop="static"
          onHide={onHide}
          {...options}
        >
          <Component
            onHide={onHide}
            onSubmit={onSubmit}
            data={modal?.data}
            access={access}
            config={config}
            values={values}
          />
        </Modal>
      )
    })
  }
  return null;
}

ModalsManager.propTypes = {
  modal: PropTypes.object,
  open: PropTypes.string,
  error: PropTypes.string,
  values: PropTypes.array,
  isLoading: PropTypes.bool,
  isLoadingSubmit: PropTypes.bool,
  onHide: PropTypes.func,
  onSubmit: PropTypes.func,
  access: PropTypes.object,
  config: PropTypes.object,
};

export default ModalsManager;
